module.exports = __webpack_public_path__ + "static/media/request-builders-illustration.8bbf690e.svg";